<div id="title" class="title">
    <ng-content select="[title]"></ng-content>
</div>
<div class="navigation-sheet" appScrollHint hintBottom="10px" [ngClass]="{'hide-footer': whiteLabel }">
    <ng-content select="[card]"></ng-content>
</div>
